import { BeneficiaryRelationship } from './useBeneficiaryRelationshipsTypes.query';

export enum AppBeneficiaryField {
  id = 'id',
  relationshipType = 'relationshipType',
  name = 'name',
  taxId = 'taxId',
  birthOn = 'birthOn',
  ssn = 'ssn',
  line1 = 'line1',
  line2 = 'line2',
  city = 'city',
  state = 'state',
  zipcode = 'zipcode',
  allocationPercentage = 'allocationPercentage',
}

export interface AppBeneficiaryForm {
  [AppBeneficiaryField.id]: string;
  [AppBeneficiaryField.relationshipType]: BeneficiaryRelationship;
  [AppBeneficiaryField.name]: string;
  [AppBeneficiaryField.taxId]: string;
  [AppBeneficiaryField.birthOn]: string;
  [AppBeneficiaryField.ssn]: string;
  [AppBeneficiaryField.line1]: string;
  [AppBeneficiaryField.line2]: string;
  [AppBeneficiaryField.city]: string;
  [AppBeneficiaryField.state]: string;
  [AppBeneficiaryField.zipcode]: string;
  [AppBeneficiaryField.allocationPercentage]: string;
}
